var bundler_logic = (function(){

  var addtocartobjects = [];

  var addToCart = function(updateObj){

    //console.log(updateObj);

    $.post('/cart/update.js', {
      updates: updateObj
    });

  }

  var build_ui = function(node, addtocart){

    
    if ($('.giftstrip').length > 0){

        console.log('block double giftstrip');

        return;

    }

   //console.log($(node)[0].ui.images);
    

    var found = false;
    var uiImage;
    // spesific image per category of which the product belongs to
    $($(node)[0].ui.images).each(function(indx,val){  

      // The product categories it belongs to
      if (item.Categories.indexOf(Object.keys(val)[0]) > -1){

        // Item is in category, and qualifed
        found = true;
        uiImage = val;

      }
    });

    if (!found){

      uiImage = $(node)[0].ui.images[0];
    }

    //console.log(addtocart);
    //console.log(uiImage);
    
    var giftstrip = $('<div class="giftstrip bundle_black"></div>');
    var loading = '<span><img src="https://cdn.shopify.com/s/files/1/2372/2167/files/ajax-loader_1.gif?v=1603605611" /></span>';
    var discount = $('<div class="bundler-discount">Discount will be applied at checkout</div>');
    var variant = $('<div class="bundler-crystal"></div>');
    var price = $('<div class="bundler_price_conainer"><span class="money price">$185.00</span>&nbsp;<span class="money cross">$185.00</span></div>');
    var textsection = $('<div class="bundle_text_section"></div>');
    var title = $('<div class="bundle_title">' + uiImage[Object.keys(uiImage)[0]].title  + '</div>');
    var txt = $('<div class="bundle_txt">' + uiImage[Object.keys(uiImage)[0]].description  + '</div>');
    var bndl = $('<div class="bundle_container"></div>');
    var img = $('<div><img src="' + uiImage[Object.keys(uiImage)[0]].img  + '" /></div>');

    $(addtocart).append(loading);            
    $(textsection).append(title);
    $(textsection).append(price);
    $(textsection).append(variant);
    $(textsection).append(txt);
    $(textsection).append(addtocart);
    $(textsection).append(discount);
  
    $(bndl).append(textsection);              
    $(bndl).append(img);
    $(giftstrip).append(bndl); 
    $(giftstrip).insertAfter(".tabs-wrapper");
    

    setVariants(variant,node);
    selectVariant($('.bundler-crystal a:first-child'));
    setPrice(null,node); // adding the watch price to the bundle
    addWatchToButtonObject($('.bundler-crystal a:first-child'));

    $(giftstrip).show();

    addProductIcon(node);

  }

  var addProductIcon = function(node){

      $("<div class='makeitagfit' style='cursor:pointer'>" + node.ui.productIcon + "</div>").prependTo('form[data-section=product]');

      $('form[data-section=product]').css('margin-top','10px');

      $('.makeitagfit').click(function(){

          $([document.documentElement, document.body]).animate({
              scrollTop: $(".giftstrip").offset().top - 150
          });
      });
  }

  var selectVariant = function(obj){

        //console.log($(obj).attr('price'));

        $('.bundler-crystal a').removeClass('selected');

        $(obj).addClass('selected');


  }

  var setVariants = function(variant, node){

        $(meta.product.variants).each(function(indx,val){

          var title = "";
          var class_ = "";

          if ($(val)[0].public_title != null){
              
              title = $(val)[0].public_title.toLowerCase().replace('crystal','')
          }
          else{

            class_ = "hide";
          }

          

          soldout_skip = false;

          var soldout = $('.swatch[data-option="crystal"] .soldout');

          if (soldout.length > 0){

              try {

                var glass = $(soldout).attr('data-value').split(' ')[0].toLowerCase();

                if (glass.trim() == title.trim()){

                    soldout_skip = true; 
                }
              }
              catch(e){}
          }

          //console.log(soldout_skip);

          if (soldout_skip == false) {

              var var_ = $('<a class="' + class_ + '" pid="' + $(val)[0].id + '"" price="' + $(val)[0].price + '" index="'+indx+'">' + title + '</a>');

              $(var_).click(function() {

                  selectVariant(this);
                  setPrice(this, node);
                  addWatchToButtonObject(this);
                  
              });

              $(var_).appendTo(variant);
          }

        });

  }

  var addWatchToButtonObject = function(obj){

      var thisid = $(obj).attr('pid');

      var erase = $(obj).parent().find('a[pid!="' + thisid + '"]');

      if (erase.length > 0){

        addtocartobjects[0][$(erase).attr('pid') + ''] = 0;

      }

        addtocartobjects[0][thisid + ''] = 1;

        //console.log(addtocartobjects);

  }

  var getobjectbyhandle = function(handle,node){
    
      //console.log(handle);
      //console.log(typeof(handle));
      
      var data = '' +
              '{shop {' +
                  'collectionByHandle(handle: "' + handle + '") {' +
                    'products(first:100) {' +
                      'edges {' +
                            'node {' + 
                              'title\n' +
                              'variants(first:100) {' +  
                                  'edges {' +
                                        'node {' + 
                                              'id\n' +
                                              'sku\n' +
                                              'title\n' +
                                              'compareAtPrice\n' +
                                              'price\n' +
                                              'availableForSale\n' +
                                              'image {' +
                                                  'id\n' +
                                                  'originalSrc\n' +
                                              '}' +
                                          '}' +
                                        '}' +
                                      '}' +
                                    '}' +
                                  '}' +
                                '}' +
                              '}' +
                            '}' +
                          '}';

      $.ajax({
        type: "POST",
        url: "https://torgoen-watches.myshopify.com/api/2019-07/graphql.json",
        //url:"https://torgoen-watches.myshopify.com/api/graphql",
        headers: {
              'X-Shopify-Storefront-Access-Token':"cb428c8a47b77a9e2ab6f67fe484b6e2",
              'Content-Type': "application/graphql"
        },  
        dataType: "JSON",
        data:data,
        success: function(response3){

                  actionRoot(response3, node);
              }
        });
  }

  var setBundlePrice = function(node){

      var totalValue = 0;
      var totalCompare = 0;
      // -- data.json 

      $($(node)[0].components).each(function(indx,nodeval){

        if ($(nodeval)[0].bundleType  == "item" ){

          if ($(nodeval)[0].enable){

              var price = parseInt($(nodeval)[0].price);
              var discount = parseInt($(nodeval)[0]['bundel-discount']);

              //console.log("price: " + price + " discount: " + discount);

              totalValue += price*((100-discount)/100);
              totalCompare += price;
          }
        }
        
      }); 

      node['totalValue'] = totalValue;
      node['totalCompare'] = totalCompare;

      return node;

  }

  var actionRoot = function(response3, node){

		// receive node with price / compare at price / and avialable for sale flag
        node = setShopifyProductsObject(response3,node);

    	//console.log(node);
    
        if (!node.availableForSale){

            console.log('bundle is not availableForSale');

            return;
        }
        else{

            node = setBundlePrice(node);

            //console.log(node);

            // building add-to-cart object
            build_event(node);

            // building the add-to-cart button
            var addtocart = build_button(node);

            // building the UI
            build_ui(node, addtocart);

        }
  }

  var setShopifyProductsObject = function(response3,node){

      node.availableForSale = true;

      // shopify products
      $(response3.data.shop.collectionByHandle.products.edges).each(function(indx,val){

          //console.log($(val)[0].node.variants.edges[0].node);
          
          var shopifyGraph = $(val)[0].node.variants.edges[0].node;

              // -- data.json 
              $($(node)[0].components).each(function(indx,nodeval){

                if ('sku' in $(nodeval)[0]){

                  if ($(nodeval)[0].enable){

                    if ($(nodeval)[0].sku == shopifyGraph.sku ){
                      
                      	//console.log(shopifyGraph);

                        var p = atob(shopifyGraph.id).split('/');

                        var id = p[p.length-1];

                        $(nodeval)[0]["price"] = shopifyGraph.price;
                        $(nodeval)[0]["compareAtPrice"] = shopifyGraph.compareAtPrice;
                        $(nodeval)[0]["availableForSale"] = shopifyGraph.availableForSale;
                        $(nodeval)[0]["shopifyid"] = id;

                        if (!shopifyGraph.availableForSale){

                            $(node)[0].availableForSale = false;

                        }

                    }
                  }
                }
                
              }); 

      });
    
    
      // Set Main Item Price using ProductJson-product tag cloud in the DOM
      /*
      $($(node)[0].components).each(function(indx,nodeval){

          if ($(nodeval)[0].enable){

            if ($(nodeval)[0].bundleType  == 'mainItem' ){

              var a = $('#ProductJson-product').text();
              
              var v = JSON.parse(a);

              $(nodeval)[0]["price"] = v.price/100;
              $(nodeval)[0]["compareAtPrice"] = v.compare_at_price/100;
              $(nodeval)[0]["availableForSale"] = v.available;
              $(nodeval)[0]["shopifyid"] = v.id;

            }
          }

      }); 
      */
      //console.log(node);

   return node;

  }

  var setPrice = function(obj, node){

	  // Current watch JSON 
    
      var v = {};
    
      if (obj == null){

        var a = $('#ProductJson-product').text();
        v = JSON.parse(a);
      }
      else{

		v.price = parseFloat($(obj).attr("price"));
      }

      var bundleValue = parseFloat(node.totalValue);
      var bundleCompare = parseFloat(node.totalCompare);
      var watchprice =  v.price/100;
      //var watchCompare = v.compare_at_price;
      var compare = v.compare_at_price/100;
      var currencysymbol = $('select[name=currency] option[selected=selected]').text().split(' ')[1];

      if ($('select[name=currency]').val() != 'USD'){
          bundleValue   = parseFloat(Currency.convert(bundleValue, 'USD', $('select[name=currency]').val()));
          bundleCompare = parseFloat(Currency.convert(bundleCompare, 'USD', $('select[name=currency]').val()));
      }
      

      var total        = Math.round(bundleValue + watchprice);
      var totalCompare = Math.round(bundleCompare + watchprice);

      /*
      console.log('watchprice:' + watchprice);
      console.log('watchcompare:' + compare);
      console.log('bundleprice:' + bundleValue);
      console.log('bundlecompare:' + bundleCompare);
      console.log('total:' + total);
      console.log('totalcompare:' + totalCompare);
      */

      //Using object _BISConfig that is present in the page

      $('.bundler_price_conainer .price').text(currencysymbol + total);
      $('.bundler_price_conainer .cross').text(currencysymbol + totalCompare);
    
  }

  var build_container = function(){

    if ($('.bundles_33711_container').length == 0){

      $('<div class="bundles_33711_container"></div>').appendTo('body');
    }
  }

  // Creating an Array with all the shopifyID eligiable items to add-to-cart
  var build_event = function(node){

      var updatesObj = {};

      $($(node)[0].components).each(function(indx,val){

        //console.log($(val));
        if ('shopifyid' in $(val)[0]){

          if ($(val)[0].enable){

              updatesObj[$(val)[0].shopifyid] = $(val)[0].qty;
          }

        }
        
      }); 

      addtocartobjects.push(updatesObj);
  }

  var build_checkout_event = function(){

    $('form.cartForm input[name="checkout"]').click(function(){

        bundler_logic.checkoutpress();

    });

  }

  var build_button = function(node){

     var addtocart = $(node)[0].ui.addToCartText;

     var b = $('<div class="bundle_container_"><input type="button" class="button_bundle" data="' + addtocartobjects.length + '" value="' + addtocart + '" /></div>');

     $(b).find('input').click(function(){

        var data = $(this).attr('data');

        $('.bundle_container_ span').show();

        addToCart(addtocartobjects[data-1]);

        window.setTimeout(function(){

          location.href="/cart";

        },1000);

     });

     return b;
  }

  var build_bundle = function(node){

        // call shopify's "bundle-items" collection to check availability and price
        getobjectbyhandle('bundle-items',node);

  }

  // build bundle if item (product) belongs to a category...
  // this function run only inside a product page
  // item.Categories is a give json in the product page
  var process = function(targetName, node){

    if (targetName == 'product_of_collections'){

      var found = false;

      $($(node)[0].target.product_of_collections).each(function(indx,val){

        // The product categories it belongs to
        if (item.Categories.indexOf(val) > -1){

          // Item is in category, and qualifed
          found = true;

        }

      });

      if (found){

         build_bundle(node);
      }

    }

  } 

  var int = function(){

    // console.log('bundler_logic');

    // check the json
    $(bundler_params.data["bundles_33711"]).each(function(index,val){

        if ($(val)[0].enable){

          // if target it product in a collection
          if ($(val)[0].target.product_of_collections.length > 0){

              // if this page is a product page
              if ($('body').hasClass('template-product')){

                process('product_of_collections', val);

                //console.log($(val)[0]);

              }
          }
        }
    });


  }

  var cartevents = function(cart){

    
  }

  var bundleMatch = function(){

    return false;

  }

  var checkoutpress = function(cart){

      if (!bundleMatch()){


        console.log('bundler-checkout-event');
        console.log(gifterparams.currentcart);


      }

  }

  return{

      init:int,
      cartevents:cartevents,
      checkoutpress:checkoutpress

  }

})();

bundler_logic.init();